import React from "react";
import Icon from "../UI/Icon/Icon";

import uncheckedSvg from "./images/unchecked.svg";

import "./Stepper.sass";
import { getDefaultStyles } from "../../helpers/getDefaultStyles";

export const Stepper = ({
  steps = [],
  currentStep,
  headerStyle = {},
  headerComponent = null,
  actionComponent = null,
  headerWrapperClass = "",
  theme = null,
}) => {
  return (
    <div className="stepper">
      <div style={headerStyle} className={headerWrapperClass}>
        <div className="stepper__header" style={{ color: `${ theme ? theme.secondaryTextColor : '#fff' }` }}>
          {steps.map(({ title }, index) => (
            <StepperHeader
              key={title + index}
              title={title}
              currentStep={currentStep}
              step={index + 1}
              theme={theme}
            />
          ))}
        </div>
        {headerComponent}
      </div>
      {steps.map(({ component }, index) => (
        <Step key={index} currentStep={currentStep} step={index + 1}>
          {component}
        </Step>
      ))}
      {actionComponent}
    </div>
  );
};

export const StepperHeader = ({ title, currentStep, step, theme = null, }) => {
  const { primaryColor } = getDefaultStyles(document.getElementById('body'));

  const renderStepIcon = () => {
    switch (true) {
      case currentStep > step:
        return <Icon name="stepper-done-step" color={theme ? theme.primaryColor : primaryColor} />;
      case currentStep === step:
        return <Icon name="stepper-current-step" color={theme ? theme.primaryColor : primaryColor} />;
      case currentStep < step:
        return <img src={uncheckedSvg} alt="Next Step" />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`stepper__header-title ${
        currentStep >= step ? "stepper__header_active" : ""
      }`}
    >
      <div
        className={`stepper__header-indicator ${
          currentStep >= step ? "stepper__header-indicator_active" : ""
        }`}
        style={{ background: `${currentStep >= step && theme ? theme.primaryColor : ''}` }}
      />
      <div className="stepper__header-hero">
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        {renderStepIcon()}
        <h5>{title}</h5>
      </div>
    </div>
  );
};

export const Step = ({ currentStep, step, children }) => {
  // const style = currentStep !== step ? { display: "none" } : {};

  if (currentStep !== step) return null;

  return (
    <div /* style={style} */ className="stepper__step">
      {children}
    </div>
  );
};
